<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="list"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="名称"
					>
					</el-table-column>
					<el-table-column
						prop="createrName"
						label="创建人"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						prop="diseaseName"
						label="擅长类型"
					>
					</el-table-column>
					<el-table-column
						prop="doctorName"
						label="主治医生"
					>
					</el-table-column>
					<el-table-column
						prop="agencyName"
						label="所在机构"
					>
					</el-table-column>
					<el-table-column
						prop="provinceName"
						label="省份"
					>
					</el-table-column>
					<el-table-column
						prop="cityName"
						label="城市"
					>
					</el-table-column>
					<el-table-column
						prop="areaName"
						label="区域"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:current-page="page"
						:total="total"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增筛选条件弹出框 -->
		<add 
			v-model="add_display"
			@complete="findCondition"
		></add>
		<!-- 新增筛选条件弹出框 end -->
		
		<!-- 修改筛选条件弹出框 -->
		<update
			v-model="update_display"
			:obj="update_condition"
			@complete="findCondition"
		></update>
		<!-- 修改筛选条件弹出框 end -->
		
		<!-- 删除筛选条件弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该条吗？</p>
			</div>
		</Popup>
		<!-- 删除筛选条件弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../../../api/index.js'
	import { mapState } from 'vuex'
	import Add from './components/add.vue'
	import Update from './components/update.vue'
	import BaseMethods from '../../../../../../assets/js/base.js'
	
	export default {
		mounted() {
			this.findCondition();
		},
		data() {
			return {
				loading: false,
				
				page: 1,
				total: 0,
				list: [],
				
				add_display: false,

				update_display: false,
				update_condition: {},
				
				delete_display: false,
				delete_id: ''
			}
		},
		computed: {
			...mapState([
				'allDisease'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 筛选条件切换页码
			handlePageChange(page) {
				if (this.page != page) {
					this.page = page;
					this.findCondition();
				}
			},
			// 点击新增筛选条件
			handleAddClick() {
				this.add_display = true;
			},
			// 点击修改筛选条件
			handleUpdateClick(data) {
				this.update_condition = data;
				this.update_display = true;
			},
			// 点击删除筛选条件
			handleDeleteClick(data) {
				this.delete_id = data.id;
				this.delete_display = true;
			},
			// 点击删除筛选条件弹出确定按钮
			handleDeletePopupConfirmClick() {
				const that = this;
				that.loading = true;
				var requestData = {
					id: that.delete_id
				};
				Api.deleteCustomerCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.page = 1;
						that.findCondition();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/************************ @Function *******************************/
			// 查询筛选条件
			findCondition() {
				const that = this;
				that.loading = true;
				var requestData = {
					code: null,
					conditionId: null,
					id: null,
					limit: 10,
					pageNum: that.page,
					roleId: null,
					type: 1
				};
				Api.findCustomerCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.list = [];
						res.data.data.data.forEach(v => {
							var _diseaseName = '',
								_diseaseArr = v.diseaseId ? v.diseaseId.split(',') : [];
							for (var i = 0;i < _diseaseArr.length;i++) {
								for (var ii = 0;ii < that.allDisease.length;ii++) {
									if (_diseaseArr[i] == that.allDisease[ii].id) {
										_diseaseName += `${ that.allDisease[ii].name },`;
									}
								}
							}
							_diseaseName && (_diseaseName = _diseaseName.slice(0, _diseaseName.length - 1));
							that.list.push({
								id: v.id,
								agencyId: v.uenterpriseId || '',
								name: v.explains || '',
								createrId: v.createrId || '',
								createrCode: v.createrCode || '',
								createrName: v.createrName || '',
								creatDate: BaseMethods.formatTime(v.ucreateTime),
								diseaseId: v.diseaseId ? v.diseaseId.split(',') : [],
								diseaseName: _diseaseName || '',
								doctorId: v.doctorId || '',
								doctorName: v.doctorName || '',
								agencyName: v.uenterpriseName || '',
								provinceName: v.uprovinceName || '',
								provinceCode: v.uprovinceCode || '',
								cityName: v.ucityName || '',
								cityCode: v.ucityCode || '',
								areaName: v.uareaName || '',
								areaCode: v.uareaCode || ''
							});
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 筛选条件获取每一行的key
			getConditionRowKey(row) {
				return row.id;
			}
		},
		components: {
			Add,
			Update
		}
	}
</script>

<style scoped>
</style>
